import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import WindowHead from "../../layouts/windowHead";

import DataTable from "react-data-table-component";
import { Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loaders from "../../../assets/loaders/loaders";

import { BiSearchAlt } from "react-icons/bi";
import { PiEye } from "react-icons/pi";
import { useNavigate } from "react-router-dom";


export default function ManageUrl() {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [showNav, setShowNav] = useState(false);


    // eslint-disable-next-line
    const [items, setItems] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState([]);

    useEffect(() => {
        fetchData(1, search, "", "");
    }, [search])

    const gotoView = (id, name) => {
        navigate('/manageUrl/view', { state: { viewId: id, name: name } });
    }

    /* ~~~~~~~~~COLUMNS START~~~~~~~~~ */
    const columns = [
        {
            name: "S. No.",
            selector: (_, index) => (currentPage - 1) * 20 + index + 1,
            width: "80px",
        },
        {
            name: "Campaign Name",
            selector: (row) => (row.url_name === "" || row.url_name === null) ? "-" : row.url_name,
            width: "220px",
        },
        {
            name: "Category",
            selector: (row) => (row.category === "" || row.category === null) ? "-" : row.category,
            width: "150px",
        },
        {
            name: "Short URLs",
            selector: (row) => (row.short_url_count === "" || row.short_url_count === null) ? "-" : row.short_url_count,
            width: "150px",
            sortable: true
        },
        {
            name: "Long URL",
            selector: (row) => (row.long_url === "" || row.long_url === null) ? "-" : row.long_url,
            width: "280px"
        },
        {
            name: "Expiry Date",
            selector: (row) => (row.expiry_in),
            cell: (row) => (row.expiry_in === "" || row.expiry_in === null) ? "-" : formatTime(row.expiry_in),
            width: "200px",
            sortable: true
        },
        {
            name: "Status",
            selector: (row) => (
                <Form.Check
                    type="switch"
                    defaultChecked={row.status === "ACTIVE" ? true : false}
                    onChange={() => {
                        handleToggle(row.id)
                    }}
                />
            ),
            width: "90px",
        },
        {
            name: 'View More',
            selector: (row) => (
                <span onClick={() => { gotoView(row.id, row.url_name) }}><PiEye className="icon-grey" /></span>
            ),
            width: '120px',
        }
    ];

    // DATE FORMAT - DATA TABLE
    function formatTime(time) {
        // Create a new Date object from the provided time
        const date = new Date(time);
        // Format the date part (day and month)
        const datePart = date.toLocaleDateString("en-US", { day: 'numeric', month: 'short' });
        // Get the full year
        const yearPart = date.getFullYear();
        // Format the time part (hours and minutes, 24-hour format)
        const timePart = date.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: false });
        // Combine and return the formatted date and time
        return `${datePart} ${yearPart}, ${timePart}`;
    }

    // DE-ACTIVATE
    const handleToggle = (id) => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/url_status/${id}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: localStorage.getItem("tokenn")
                }
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result.statusCode === 200) {
                    toast.success(result.message);
                } else {
                    toast.error(result.message);
                }
            });
    };

    // TABLE
    const fetchData = async (page, search) => {
        setIsLoading(true);
        fetch(
            `${process.env.REACT_APP_API_BASE_URL}/get_campaign_url_data?pageNumber=${page}&search=${search}&limit=&from=&to=&category=`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("tokenn")
                }
            })
            .then((res) => res.json())
            .then(
                (result) => {
                    setIsLoading(false);
                    setItems(result?.data?.result?.data);
                    setFilter(result?.data?.result?.data);
                    setTotalRows(result?.data?.result?.totalPosts);
                },
                (error) => {
                    setIsLoading(false);
                    toast.error(error.message);
                }
            );
    };


    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, "", "", "");
    };

    // useEffect(() => {
    //   const result = items.filter((data) => {
    //     return data.Policy_No.toLowerCase().match(search.toLocaleLowerCase());
    //   });
    //   setFilter(result)
    // }, [search, items])


    // useEffect(() => {
    //   fetchData(1, search);
    // }, [search]);


    // const handlePerRowsChange = async (rowperpage, page) => {
    //   fetchData(page, "", "");
    // };

    // const downloadFile = () => {
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = `${process.env.REACT_APP_API_BASE_URL}/download-campaign-urls?from=&to=&category=`
    //     downloadLink.download = 'Campaign-Details.csv'; // Provide the desired filename for download
    //     downloadLink.click();
    // }

    return (
        <>
            {isLoading && <Loaders />}
            <ToastContainer />


            <div className="bg-inner">
                <Sidebar show={showNav} onClose={() => setShowNav(false)} />
                <div className="d-flex flex-column ms-0 ms-xxl-3 col-12 col-sm-12 col-xxl-9">
                    <WindowHead sidebarOpen={() => setShowNav(!showNav)} />


                    <div className="main-content">
                        <div className="d-flex align-itms-center justify-content-between flex-wrap for-border">
                            <span>
                                <h4 className="m-0">Manage URLs</h4>
                                <p>Create unique Short URLs for each user as a Campaign here.</p>
                            </span>
                            <div className="my-2 my-lg-0 d-flex align-itms-center">
                                <button
                                    onClick={() => navigate('/manageUrl/create')}
                                    className="add_btn">
                                    <i className="fa-solid fa-upload fa-l"></i> New URL
                                </button>
                            </div>
                        </div>
                        <div className="uploaded_items">

                            {/* <div className="my-2 m-md-0 d-flex">
                                <button onClick={() => downloadFile()} className="dnld-btn ms-auto">
                                    <PiFileCsvDuotone className="icon-grey" /> Export Data
                                </button>
                            </div> */}

                            <DataTable
                                className="custom_tborder"
                                columns={columns}
                                data={filter}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                onChangePage={handlePageChange}
                                paginationPerPage={20}
                                paginationRowsPerPageOptions={[20]}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                paginationComponentOptions={""} // Pass the custom options here
                                fixedHeader
                                fixedHeaderScrollHeight="460px"
                                selectableRowsHighlight
                                highlightOnHover
                                subHeader
                                subHeaderComponent={
                                    // <div className="d-flex w-100 align-items-center">
                                    <div className="w-75">
                                        <span className="d-flex w-50 me-2">
                                            <label htmlFor="gsearch" className="srch-btn"><BiSearchAlt /></label>
                                            <input type="search" className="form-control srch-fld" id="gsearch" placeholder='Search by URL'
                                                onChange={(e) => e.target.value}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setSearch(e.target.value);
                                                    }
                                                }} />
                                        </span>
                                    </div>
                                    //     <div className="w-25 d-flex">
                                    //         <button onClick={() => downloadFile()} className="dnld-btn ms-auto">
                                    //             <PiFileCsvDuotone className="icon-grey" /> Export Data
                                    //         </button>
                                    //     </div>
                                    // </div>
                                }
                                subHeaderAlign="left"
                            />

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
